import { IListModelQueryParamValues, IModelJsonValues } from '@sparelabs/http-client-utils'

export enum FormContentStatus {
  Active = 'active',
  Archived = 'archived',
}

export enum FormContentStage {
  Default = 'default',
  PostSubmit = 'postSubmit',
}

export enum FormContentType {
  Default = 'default',
  Divider = 'divider',
  Conditional = 'conditional',
}

export enum FormContentVisibility {
  Hidden = 'hidden',
  View = 'view',
}

export interface IListFormContentQueryParams extends IListModelQueryParamValues {
  formId?: string
  status?: FormContentStatus
}

export interface IFormContentPostBody {
  name: string
  formId: string
  order: string
  content: string
  type: FormContentType
  stage: FormContentStage
  riderInterfaceVisibility: FormContentVisibility
  conditions: IConditionBranchingRules[] | null
}

export interface IFormContentPatchBody {
  name?: string
  status?: FormContentStatus
  order?: string
  content?: string
  type?: FormContentType
  riderInterfaceVisibility?: FormContentVisibility
  conditions?: IConditionBranchingRules[] | null
}

export interface IFormContentResponse extends IModelJsonValues, IFormContentPostBody {
  status: FormContentStatus
  stage: FormContentStage
}

export enum ConditionBranching {
  And = 'and',
  Or = 'or',
}

export enum ConditionOperator {
  Equal = '==',
}

export interface IJsonLogicRule {
  [ConditionOperator.Equal]: [{ var: string }, string | boolean]
}

export interface IConditionBranchingRules {
  rules: IJsonLogicRule[]
  operator: ConditionBranching | null
  skipToContentId: string
}
